module.exports = __webpack_public_path__ + "img/6.62d4ca91.png";